<template>
  <div class="hello">
    <h1>{{ $t('site.home.welcome') }}</h1>

    <div v-if="viewAsPlayer.username">
    {{ $t('site.playerSelection.youAreViewing', viewAsPlayer) }} <router-link to="/changePlayer">{{ $t('site.playerSelection.changeUser') }}</router-link>
    </div>

    <div class="row" v-if="!viewAsPlayer.username">
      <div class="col-md-6">
        <div class="panel">
          <div class="panel-content bg-secondary">
            <h2>{{ $t('site.playerSelection.enterYourUsernameToGetStarted') }}</h2>
            <elv-player-search-box :emitViewAsPlayer="true"/>
            <small>{{ $t('site.playerSelection.thisIsNotASignup') }}</small>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/KXkxGEUyv-Y?rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </div>
    </div>
    <div class="row" v-else>
        <div class="col-md-6">
          <h2>{{ $t('site.demo') }}</h2>
      <iframe width="560" height="315" src="https://www.youtube.com/embed/KXkxGEUyv-Y" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        </div>
        <div class="col-md-6">
          <h2>{{ $t('site.nav.news') }}</h2>
          <div class="panel">
            <elv-release-notes style="max-height: 315px; overflow-y: scroll"></elv-release-notes>
          </div>
        </div>
    </div>

    <h2>{{ $t('site.home.features.headline') }}</h2>
    <div class="row homeFeatures">
      <div class="col-md-6">
        <div class="panel">
          <div class="panel-content active">
            <h1 v-html="this.$i18n.t('site.home.features.fellowshipAdministration.headline')"></h1>
            <div style="overflow: hidden;">
              <ul>
                <li>{{ $t('site.home.features.fellowshipAdministration.bullet1') }}</li>
                <li>{{ $t('site.home.features.fellowshipAdministration.bullet2') }}</li>
                <li>{{ $t('site.home.features.fellowshipAdministration.bullet3') }}</li>
              </ul>
              <img class="center" src="../assets/feature-goodsBreakdownWithDrilldownHorizontal.png">
              <BR/>
              <img class="center" src="../assets/weeklyReportExample.png" width="500">
            </div>
          </div>
        </div>
        <div class="panel">
          <div class="panel-content">
            <h1 v-html="this.$i18n.t('site.home.features.advancedRankingLists.headline')"></h1>
            <ul>
              <li>{{ $t('site.common.comingSoon') }} - {{ $t('site.home.features.advancedRankingLists.bullet1') }} </li>
              <li>{{ $t('site.home.features.advancedRankingLists.bullet2') }}</li>
            </ul>
            <img src="../assets/feature-rankingLists-300.png" class="center">
          </div>
        </div>
        <div class="panel">
          <div class="panel-content">
            <h1 v-html="this.$i18n.t('site.home.features.fellowshipTournamentTracking.headline')"></h1>
            {{ $t('site.home.features.fellowshipTournamentTracking.description') }}
            <img class="center" src="../assets/feature-tournamentFellowshipTracking.png">
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="panel">
          <div class="panel-content">
            <h1 v-html="this.$i18n.t('site.home.features.matchMaking.headline')"></h1>
            {{ $t('site.home.features.matchMaking.description') }}
            <img class="center" src="../assets/feature-idealCandidate.png">
          </div>
        </div>
        <div class="panel">
          <div class="panel-content">
            <h1 v-html="this.$i18n.t('site.home.features.elvenArchitectIntegration.headline')"></h1>
            {{ $t('site.home.features.elvenArchitectIntegration.description') }}
            <img class="center" src="../assets/feature-elvenArchitectLoad.png">
          </div>
        </div>
      </div>
    </div>


    <!--<h2>GET STARTED</h2>-->
    <!--Enter your elvenar player name in the input box below and the site will be customized for you!-->
    <!--No signup required, we just use this information to populate the My Fellowship and My Ranking sections of the site and make a list of recommended fellowships.-->

    <h2>{{ $t('site.nav.globalStats') }}</h2>
    <div class="row">
      <div class="col-md-6">
        <div class="panel">
          <div class="panel-header panel-controls"><h3><i class="fas fa-server"></i> Top {{$t('site.nav.fellowships')}} <strong>{{ $t('site.common.allServers') }}</strong></h3></div>
          <div class="panel-content">
            <elv-fellowship-ranking-table :fellowships="topFellowships"></elv-fellowship-ranking-table>
          </div>
        </div>
      </div>
    </div>

    <br/>
    <mail-chimp-signup></mail-chimp-signup>
  </div>
</template>

<script>
  import axios from 'axios';
  import _ from 'lodash';
  let elvenStats = require('../lib/elven-stats');
  import ElvFellowshipRankingTable from '@/components/ElvFellowshipRankingTable';
  import ElvPlayerSearchBox from '@/components/ElvPlayerSearchBox';
  import ElvReleaseNotes from "@/components/ElvReleaseNotes"
  import BrLanguageSelector from "@/components/BRLanguageSelector"
  import LocaleSwitcher from "@/components/LocaleSwitcher"
  import MailChimpSignup from "@/components/MailChimpSignup";

export default {
  name: 'Home',
  components: {
      MailChimpSignup,
      LocaleSwitcher,
      BrLanguageSelector,
      ElvReleaseNotes,
      ElvFellowshipRankingTable, ElvPlayerSearchBox},
  props: ['viewAsPlayer'],
  data () {
    return {
        topFellowships: [],
    }
  },
  mounted() {
      var self = this;
      console.log("view As Player in home");
      console.log(this.viewAsPlayer);
      axios.get(`/api/fellowships/top`).then( function(response) {
          self.topFellowships = response.data;
          //console.log(response.data);
          _.each(self.topFellowships, function(s) {
              try {
                  s.serverName = elvenStats.mapDomainAndServerName( s.server );
                  s.lastWeeksChange = 0;
                  s.lastWeeksChange = s.scoreHistory[ s.scoreHistory.length-1 ].score - s.scoreHistory[ s.scoreHistory.length-2 ].score;
              }catch(err) {
                  //console.error("Unable to calculate lastWeeksGrowth", err);
              }
          });
      });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .center { display: block; margin-left: auto; margin-right: auto; }
  .homeFeatures ul { margin-left: 20px; }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue